export enum ReactionType {
    Like = 0,
    Dislike = 1,
}